<template>
  <v-app
    id="app"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <component :is="layout">
      <router-view></router-view>
    </component>
    <NotificationContainer />
  </v-app>
</template>

<script>
import NotificationContainer from "@/components/NotificationContainer.vue";

export default {
  components: {
    NotificationContainer
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || "Default") + "-layout";
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    }
  },
  name: "App"
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Lato:400,400i,700,700i&display=swap");

body .v-application {
  font-family: "Lato", sans-serif;
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}
.loading-icon {
  animation: rotate 1.5s linear infinite;
}

.v-application .v-dialog__content {
  align-items: flex-start;
}
</style>
